import React, { Component } from 'react'
import { Col, Label, Row } from 'reactstrap'
import Card from '../../comum/components/Card';
import { inject, observer } from 'mobx-react';
import _ from "lodash"
import moment from "moment"

@inject("store")
@observer
export default class ConsultaSituacaoAcomp extends Component {
    constructor(props){
        super(props)

        this.controller = this.props.controller

        this.colunas = [{
            name: "Situação",
            param: "DescStatus"
        },{
            name: "Nº do processo",
            param: "DocumentoDespacho"
        },{
            name: "Despachante",
            param: "Despachante"
        },{
            name: "Transportadora",
            param: "Transportadora"
        },{
            name: "SISCOMEX",
            param: "DataSiscomex"
        }
    ]
    }
    render() {
        return (
            <div>
                <h2>Consulta de situação de processo</h2>
                <Card>
                    <Row>
                        {this.colunas.map((elem, index) => <Col key={index} xs={12} sm={6} md={4} lg={2} xl={2} >
                            <Label className="label-secondary">{elem.name.toUpperCase()}</Label>
                            <div>
                                <Label className="label-disabled">
                                    {_.get(this.controller.dadosSituacao, elem.param) ? 
                                        elem.name==="SISCOMEX" ? moment(_.get(this.controller.dadosSituacao, elem.param)).format("DD/MM/YYYY HH:mm") : 
                                                                 _.get(this.controller.dadosSituacao, elem.param)
                                    : ""}
                                </Label>
                            </div>
                        </Col>)}
                    </Row>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/ConsultaSituacaoAcomp.js